/**
 * Check if a Role Requirement question is from the ANZ question library by checking the globalId.
 * Only used for a few RR localId checks for RTW question, Range questions and Advanced Availability.
 * This is a hack and can be removed after old RR questionnaires can no longer be viewed.
 * @param globalId - Role Requirements Global ID for a question or an answer.
 * @returns `true` if the `globalId` starts with `AU_`, `NZ_` or `AUS_` and is therefore from the AU, NZ, or ANZ question library.
 */
export const isAuOrNzRRQuestion = (globalId: string | null) =>
  globalId &&
  (globalId.startsWith('AU_') ||
    globalId.startsWith('NZ_') ||
    globalId.startsWith('AUS_'));
